export const API_KEY = process.env.REACT_APP_API_BASE;
export const SERVER_KEY = process.env.REACT_APP_SERVER_BASE;
export const MATCHING_API_KEY =
  process.env.REACT_APP_MATCHING_API_BASE || process.env.REACT_APP_API_BASE;
